<!-- 書類の使用頻度のサンプル datasetsとかlabels入れたら表示できる-->
<script>
import { Bar } from "vue-chartjs";
export default {
  extends: Bar,
  name: "DocumentRejectionRate",
  type: "bar",
  // データを分割表示するためのprops
  props: {indexMin: String, indexMax: String, default: () => {return {indexMin: "", indexMax: ""}}},
  data() {
    return {
      data: {
        datasets: [
          {
            label: "書類別却下率(%)",
            data: [10, 20, 30, 10, 100],
            backgroundColor: "#ff9896",
          },
        ],
        labels: ["document111", "document2", "document3", "document4", "document5"],
      },
      options: {
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "書類",
              },
              ticks: {
                autoSkip: true,
                min: "",
                max: "",
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                autoSkip: true,
                max: 100,
                stepSize: 10,
              }
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  computed: {
    documentRejectionRateList: function () {
      return this.$store.getters["domain/documentRejectionRateList"];
    },
  },
  watch: {
    documentRejectionRateList(val) {
      if (val) {
        this.overwriteGraphData(val);
      }
      this.renderChart(this.data, this.options);
    },
    indexMin (val) {
      this.$set(this.options.scales.xAxes[0].ticks, "min", val || "");
      this.renderChart(this.data, this.options);
    },
    indexMax (val) {
      this.$set(this.options.scales.xAxes[0].ticks, "max", val || "");
      this.renderChart(this.data, this.options);
    }
  },
  mounted() {
    const val = this.$store.getters["domain/documentRejectionRateList"];
    if(val){
      this.overwriteGraphData(val);
    }
    this.renderChart(this.data, this.options);
  },
  methods: {
    overwriteGraphData: function (val) {
      let documentId = [];
      let rejectinRate = [];
      for (let i = 0; i < val.length; i++) {
        const data = val[i];
        documentId.push(data.document_id);
        rejectinRate.push(data.rejection_rate);
      }
      this.$set(this.data.datasets[0], "data", rejectinRate);
      this.$set(this.data, "labels", documentId);
    },
  }
};
</script>
